import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

type Variant = "primary" | "secondary" | "ghost" | "outline";
type Size = "md" | "lg" | "sm";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const variants: Record<Variant, string> = {
  primary:
    "bg-primary text-primary-foreground shadow-press active:translate-y-1 active:shadow-none",
  secondary:
    "bg-secondary text-secondary-foreground shadow-[0_5px_0_0_oklch(0.32_0.08_140)] active:translate-y-1 active:shadow-none",
  outline: "bg-card border-2 border-clay text-foreground hover:bg-clay/20",
  ghost: "bg-transparent hover:bg-clay/20 text-foreground",
};

const sizes: Record<Size, string> = {
  sm: "px-4 py-2 text-sm rounded-xl",
  md: "px-6 py-3 text-base rounded-2xl",
  lg: "px-7 py-4 text-lg rounded-2xl",
};

export const JButton = forwardRef<HTMLButtonElement, Props>(
  ({ variant = "primary", size = "md", className, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        "font-bold transition-all disabled:opacity-50 disabled:pointer-events-none inline-flex items-center justify-center gap-2",
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    />
  ),
);
JButton.displayName = "JButton";
